import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import { selectIsCurrentUserInstructor } from 'store/features/auth/selectors';
import routeTemplates from 'ui/common/routes/templates';
import Menu from 'ui/common/menu';
import routeGenerators from 'ui/common/routes/generators';

export class AdminNavItems extends Component {
  render() {
    let { isCurrentUserInstructor } = this.props;
    return (
      <li className="nav-item my-auto pr-3">
        <Menu
          text={
            isCurrentUserInstructor ? (
              <FormattedMessage id="app.layout.header.instructor" defaultMessage="DAK INSTRUCTOR" />
            ) : (
              <FormattedMessage id="app.layout.header.adminsdh" defaultMessage="DAK ADMIN" />
            )
          }
          isButton
        >
          {!isCurrentUserInstructor && (
            <DropdownItem tag={RouterLink} to={routeTemplates.admin.users.index}>
              <FormattedMessage id="app.layout.header.admin.users" defaultMessage="Users" />
            </DropdownItem>
          )}
          {/*<DropdownItem tag={RouterLink} to={routeTemplates.admin.track.root}>*/}
          {/*  <FormattedMessage id="app.layout.header.admin.tracks" defaultMessage="Tracks" />*/}
          {/*</DropdownItem>*/}
          <DropdownItem tag={RouterLink} to={routeTemplates.admin.modules.root}>
            <FormattedMessage id="app.layout.header.admin.companies" defaultMessage="Modules" />
          </DropdownItem>
          {!isCurrentUserInstructor && (
            <DropdownItem tag={RouterLink} to={routeTemplates.admin.profiler.root}>
              <FormattedMessage
                id="app.layout.header.admin.profiler"
                defaultMessage="Profiling Exercise"
              />
            </DropdownItem>
          )}
          {/*<DropdownItem tag={RouterLink} to={routeTemplates.admin.hiring.root}>*/}
          {/*  <FormattedMessage*/}
          {/*    id="app.header.layout.admin.hiring"*/}
          {/*    defaultMessage="Hiring Companies"*/}
          {/*  />*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem tag={RouterLink} to={routeTemplates.admin.preassess.root}>*/}
          {/*  <FormattedMessage*/}
          {/*    id="app.layout.header.admin.pre-assess"*/}
          {/*    defaultMessage="Pre Assessments"*/}
          {/*  />*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem tag={RouterLink} to={routeTemplates.admin.behaviorExercise.root}>*/}
          {/*  <FormattedMessage*/}
          {/*    id="app.layout.header.admin.behavior-exe"*/}
          {/*    defaultMessage="Behavioural Exercise"*/}
          {/*  />*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem tag={RouterLink} to={routeTemplates.admin.behavassess.root}>*/}
          {/*  <FormattedMessage*/}
          {/*    id="app.layout.header.admin.behav-assess"*/}
          {/*    defaultMessage="Behavioural Templates"*/}
          {/*  />*/}
          {/*</DropdownItem>*/}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.skills.root}>
            <FormattedMessage id="app.layout.header.admin.skills" defaultMessage="Skills" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.badges.root}>
            <FormattedMessage id="app.layout.header.admin.badges" defaultMessage="Badges" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.claims.root}>
            <FormattedMessage id="app.layout.header.admin.claims" defaultMessage="Claims" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.assignments.root}>
            <FormattedMessage
              id="app.layout.header.admin.assignments"
              defaultMessage="Assignments"
            />
          </DropdownItem> */}
          {!isCurrentUserInstructor && (
            <DropdownItem tag={RouterLink} to={routeTemplates.admin.stats.root}>
              <FormattedMessage id="app.layout.header.admin.stats" defaultMessage="Stats" />
            </DropdownItem>
          )}
          <DropdownItem tag={RouterLink} to={routeGenerators.admin.reports.root({ companyId: '' })}>
            <FormattedMessage id="app.layout.header.admin.reports" defaultMessage="Reports" />
          </DropdownItem>
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.templates.root}>
            <FormattedMessage id="app.layout.header.admin.templates" defaultMessage="Templates" />
          </DropdownItem> */}
          {/* <DropdownItem tag={RouterLink} to={routeTemplates.admin.features.root}>
            <FormattedMessage id="app.layout.header.features.stats" defaultMessage="Features" />
          </DropdownItem> */}
        </Menu>
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isCurrentUserInstructor: selectIsCurrentUserInstructor(state),
  };
}

export default withRouter(connect(mapStateToProps)(AdminNavItems));



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/admin.js